import { render, staticRenderFns } from "./UIMaskInput.vue?vue&type=template&id=6df0b9ce&"
import script from "./UIMaskInput.vue?vue&type=script&lang=js&"
export * from "./UIMaskInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports